import {IManagableObject} from "./IManagableObject";
import { ObjectGroupUserLink } from "app/models/ObjectGroupUserLink";

export class ObjectGroupViewModel implements IManagableObject {
  Id: number = 0;
  CompanyId: number = 0;
  Name: string;
  CanSelect?: boolean;
  //Count: number = 0;
  objects: number[] = [];
  Users?: ObjectGroupUserLink[];

  ///workaround
  isMgmtOpen: boolean = false;
  mgmtxPos: number;
  mgmtyPos: number;

  init(data?: any) {
    if (data) {
      this.Id = data["id"];
      this.CompanyId = data["companyId"];
      this.Name = data["name"];
      this.CanSelect = data["canSelect"];
      //this.Count = data["count"];
      this.objects = data["objects"];
      this.Users = data["users"];
    }
  }

  static fromJS(data: any): ObjectGroupViewModel {
    data = typeof data === 'object' ? data : {};
    let result = new ObjectGroupViewModel();
    result.init(data);
    return result;
  }

  IsChecked: boolean;
}
